import React from 'react';
export function FinalCTA() {
  return <section id="contact" className="relative py-24 md:py-32 overflow-hidden" data-id="element-46">
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/77r8AfzdRVbMXpNuQsUPFq/travis-essinger-3ZSz6xhNVEs-unsplash.jpg")',
      backgroundAttachment: 'fixed'
    }} data-id="element-47">
        <div className="absolute inset-0 bg-brand-stone-900/80 backdrop-blur-sm" data-id="element-48"></div>
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6 text-center" data-id="element-49">
        <h2 className="text-4xl md:text-6xl font-serif text-white mb-6" data-id="element-50">
          Ready to make your move?
        </h2>
        <p className="text-brand-silver text-lg md:text-xl max-w-2xl mx-auto mb-10 font-light" data-id="element-51">
          Whether you're buying your first home or selling a luxury estate, our
          team is ready to guide you.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 mb-8" data-id="element-52">
          <button className="w-full md:w-auto bg-white hover:bg-brand-cream text-brand-stone-900 px-10 py-4 rounded-lg font-medium transition-colors text-lg" data-id="element-53">
            Find Your Home
          </button>
          <button className="w-full md:w-auto border-2 border-white text-white hover:bg-white hover:text-brand-stone-900 px-10 py-4 rounded-lg font-medium transition-colors text-lg" data-id="element-54">
            Sell Your Home
          </button>
        </div>

        <a href="tel:3035475468" className="inline-block text-brand-copper hover:text-white transition-colors text-xl font-serif" data-id="element-55">
          Call us at (303) 547-5468
        </a>
      </div>
    </section>;
}